import { DeploymentTypeEnum } from "@superblocksteam/shared";

import { SUPERBLOCKS_UI_DEPLOYMENT_TYPE } from "env";

/**
 * Cloud-prem deployments pay by contract and have no Stripe-backed billing
 * surfaces. Use this predicate to short-circuit billing hooks, paywall UI,
 * and any component that would otherwise fetch from /api/v1/billing/*.
 */
export function isCloudPrem(): boolean {
  return SUPERBLOCKS_UI_DEPLOYMENT_TYPE === DeploymentTypeEnum.CLOUD_PREM;
}
